"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab["default"];
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _Tabs["default"];
  }
});
var _Tabs = _interopRequireDefault(require("./Tabs"));
var _Tab = _interopRequireDefault(require("./Tab"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }